// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 10,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
  },
  header: {
    borderRadius: '10px 10px 0 0',
    background: 'linear-gradient(180deg, rgba(60,170,236,1) 0%, rgba(91,220,255,1) 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerText: {
    margin: '12px 0',
    color: GlobalStyles.color.COLOR_PRIMARY,
  },
  bottomContainer: {
    padding: 16,
  }
});

export default styles;
